const contentKeys = {
	ServerImageCreate: 'ServerImageCreate',
	StyledTextEm: 'StyledTextEm',
};

export default contentKeys;
